import { useAuth } from "@clerk/clerk-react";
import { useMemo } from "react";
import { BiosApi } from "./api.js";

export function useApiAuthed(): BiosApi {
  const { getToken } = useAuth();
  return useMemo(
    () =>
      new BiosApi(async () => {
        const token = await getToken();
        return token ?? null;
      }),
    [getToken],
  );
}

export function useApiDev(): BiosApi {
  return useMemo(() => new BiosApi(async () => "dev_admin_dev_user"), []);
}
